import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description FinancialPortfolio icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { FinancialPortfolio } from '@sravni/design-system-icons'
 *
 * <FinancialPortfolio />
 * ```
 */
var FinancialPortfolio = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "FinancialPortfolio", viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10.736 9.166v-.833M10.736 14.166V15M9.29 13.57c.215.354.584.598 1.03.598h.913a1.17 1.17 0 0 0 .284-2.306l-1.563-.392a1.17 1.17 0 0 1 .285-2.304H11.153c.444 0 .812.243 1.027.595", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M16.57 17.083H4.903c-.92 0-1.667-.745-1.667-1.666v-7.5c0-.921.746-1.667 1.667-1.667H16.57c.92 0 1.666.746 1.666 1.667v7.5c0 .92-.745 1.666-1.666 1.666Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M14.214 6.25V4.583c0-.92-.745-1.667-1.666-1.667H8.924c-.92 0-1.666.746-1.666 1.667V6.25", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { FinancialPortfolio };
//# sourceMappingURL=FinancialPortfolio.js.map
